import { useEffect, useState } from "react";
import { useUserServices } from "../../context/DealerProfile";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Modal } from "flowbite-react";
import toast from "react-hot-toast";

const CancelOrderForm = () => {
  const { dealerDetail } = useUserServices();
  const { accountName, dealerName } = dealerDetail || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    Cancel_Description: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate(); // Get navigate function
  const { orderId } = useParams();

  const orderNum = orderId?.split?.("-")?.[1];
  const orderIds = orderId?.split?.("-")?.[0];

  useEffect(() => {
    if (orderId) {
      setIsModalOpen(true);
    }
  }, [orderId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate Cancel Description
    if (!formData.Cancel_Description) {
      newErrors.Cancel_Description = "Cancel Description is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (validateForm()) {
      const requestBody = {
        Cancel_Description: formData.Cancel_Description,
        Return_Status: "Pending",
        Order_Number: orderIds,
      };

      if (dealerName?.id) requestBody["Customer"] = dealerName?.id;
      if (accountName?.id) requestBody["Channel_Partner"] = accountName?.id;

      const loadingToast = toast.loading("Creating Cancel Order...");

      try {
        const response = await fetch(
          `/server/dealer_backend/create-cancel-order`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        await response.json();

        toast.success("Cancel Order Created successfully!", {
          id: loadingToast,
        });

        setIsModalOpen(false); // Close the modal after submission
        setFormData({
          Cancel_Description: "",
        });
        navigate("/cancel-order");
      } catch (error) {
        console.error("Error submitting Cancel Order:", error);
        toast.error("Failed to add Cancel Order. Please try again.", {
          id: loadingToast,
        });
      }
    } else {
      toast.error("Please fix the errors in the form.");
    }
  };

  useEffect(() => {
    if (!isModalOpen) setErrors({});
  }, [isModalOpen]);

  return (
    <div className="px-4 max-w-5xl mx-auto">
      <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Modal.Header>Create Cancel Request</Modal.Header>
        <Modal.Body>
          <div className="flex flex-col gap-5">
            <div>
              <label className="block mb-2 font-semibold">
                Order Number<span className="text-red-500">*</span>
              </label>
              <input
                name="name" // Changed to "Name"
                readOnly
                value={orderNum}
                className={`border rounded-md cursor-not-allowed ${
                  errors.name ? "border-red-500" : "border-gray-300"
                } p-2 w-full`}
              />
            </div>
            <div>
              <label className="block mb-2 font-semibold">
                Reason For Cancellation<span className="text-red-500">*</span>
              </label>
              <textarea
                name="Cancel_Description"
                value={formData.Cancel_Description}
                onChange={handleChange}
                rows={4}
                cols={10}
                className={`border rounded-md ${
                  errors.Cancel_Description
                    ? "border-red-500"
                    : "border-gray-300"
                } p-2 w-full`}
              />
              {errors.Cancel_Description && (
                <p className="text-red-500">{errors.Cancel_Description}</p>
              )}
            </div>

            <Button onClick={handleSubmit}>Cancel Request</Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CancelOrderForm;
